<template>
  <div class="bid-data">
    <div class="bid-data-header">
      <ul>
        <li>起运地/目的地</li>
        <li>货源信息</li>
        <li>邀请时间</li>
        <li>操作</li>
      </ul>
    </div>
    <div class="bid-data-body">
      <template v-for="(item, index) of bidData">
        <div :key="index" class="data-item">
          <ul>
            <li :title="item.price">{{ item.price }}</li>
            <li :title="item.companyName">{{ item.companyName }}</li>
            <li :title="item.shipmentName">{{ item.shipmentName }}</li>
            <li>
              <el-button type="text" @click="quotation(item)">报价</el-button>
              <el-divider direction="vertical" />
              <el-button type="text" @click="refuseBid(item)">成交</el-button>
            </li>
          </ul>
        </div>
      </template>
    </div>
    <div class="bid-data-pagination">
      <el-pagination
        :current-page="bidPagination.pageNo"
        :total="bidPagination.total"
        :page-size="bidPagination.pageSize"
        layout="prev, pager, next, jumper,total, sizes"
        @current-change="bidChangeCurrent"
        @size-change="bidChangeSize"
      />
    </div>

    <el-dialog :visible.sync="quotationVisible" width="30%" title="报价" append-to-body>
      <el-form class="quotation-form">
        <div class="form-line">
          <el-form-item>
            <el-input v-model="selectedItem.expectPrice" placeholder="请输入你的报价" />
          </el-form-item>
          <div class="quotation-label">
            元/吨
          </div>
        </div>
        <div class="form-line">
          <el-form-item>
            <el-button class="quotation-form-btn quotation-btn" @click="updateExpectPrice">报价</el-button>
          </el-form-item>
          <el-form-item>
            <el-button class="quotation-form-btn" @click="quotationVisible=false">取消</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { Page } from '@/utils/commonDataModel'
import { updateExpectPrice } from '@/api/personal/find/goodsManager'

export default {
  props: {
    // 货源id
    transportId: { type: String, default: '' }
  },
  data: function() {
    return {
      bidData: [],
      selectedItem: {
        id: '',
        expectPrice: 0
      },
      // 竞价列表表格分页
      bidPagination: new Page(),
      // 报价弹窗是否可见
      quotationVisible: false
    }
  },
  watch: {
    transportId: {
      immediate: true, // 在监听开始后立即回调
      handler(val) {
        this.loadBidData()
      },
      deep: true
    }
  },
  methods: {
    updateExpectPrice() {
      // 发起报价请求
      updateExpectPrice({ goodsId: this.selectedItem.id, offerPrice: this.selectedItem.expectPrice }).then(data => {
        this.$message({
          message: '报价成功',
          type: 'success'
        })
        this.quotationVisible = false
      }).catch(error => {
        console.error(error)
      })
    },
    // 报价
    quotation(item) {
      this.quotationVisible = true
      this.selectedItem = JSON.parse(JSON.stringify(item))
    },
    bidChangeSize(size) {
      this.bidPagination.pageSize = size
      this.loadBidData()
    },
    bidChangeCurrent(current) {
      this.bidPagination.pageNo = current
      this.loadBidData()
    },
    loadBidData() {
      // 模拟请求
      this.bidData = [
        { id: '6666',
          price: '1000',
          companyName: '广通物流有限公司',
          shipmentTel: '1870000000',
          weight: '500吨',
          time: '2019-7-1 12:00'
        }
      ]
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/styles/standardColor.scss";

$main-color: #be2316;
.bid-data {
  .bid-data-header {
    color: $main-color;
    font-weight: bold;
    background-color: #ffffff;
    height: 45px;
    margin-bottom: 1rem;
    ul {
      display: flex;
      flex-wrap: nowrap;
      height: 100%;
      width: calc(100% - 16px);
      padding: 8px 8px;
      box-sizing: content-box;
      li {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 15px;
        min-width: 50px;
        height: 100%;
        line-height: 29px;
        text-align: center;
        &:nth-child(1) {
          flex-basis: 25%;
        }
        &:nth-child(2) {
          flex-basis: 25%;
        }
        &:nth-child(3) {
          flex-basis: 25%;
        }
        &:nth-child(4) {
          flex-basis: 25%;
        }
      }
    }
  }
  .bid-data-body {
    position: relative;
    .data-item {
      margin: 8px 0;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border: 1px solid #ebeef5;
      position: relative;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 56px;
        width: calc(100% - 16px);
        padding: 8px 8px;
        position: relative;
        background-color: white;
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 64px;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 25%;
          }
          &:nth-child(2) {
            flex-basis: 25%;
          }
          &:nth-child(3) {
            flex-basis: 25%;
          }
          &:nth-child(4) {
            flex-basis: 25%;
          }
        }
      }
      /deep/ .goods-item-details {
        border: 1px solid #ebeef5;
        z-index: 0;
      }
    }
  }
  .bid-data-pagination {
    margin-top: 24px;
    padding: 16px 0;
    background-color: white;
  }
}

/deep/.el-form.quotation-form {
  display: flex;
  flex-direction: column;
  .form-line{
    display: flex;
    flex-direction: row;
    margin: auto;
    .quotation-label{
      line-height: 40px;
    }
    .quotation-form-btn{
      background-color: #A7A7A7!important;
      color: white;
      border-radius: 15px;
      width: 100px;
    }
    .quotation-btn{
      background-color: #BE2316!important;
      margin-right: 2rem;
    }
  }
  .el-input{
    width: 90%;
    margin-right: 0.5rem;
    font-size: 24px;
    .el-input__inner{
      text-align: center;
      color: #FF0000!important;
    }
  }
}

</style>
